import { combineReducers } from "redux"

import { calculatorReducer } from "./calculator.reducer"
import { embedCalculatorReducer } from "./embedCalculator.reducer"
import { intakeDemoReducer } from "./intakeDemo.reducer"
import { runtimeReducer } from "./runtime.reducer"

export const rootReducer = combineReducers({
    runtime: runtimeReducer,
    calculator: calculatorReducer,
    embedCalculator: embedCalculatorReducer,
    intakeDemo: intakeDemoReducer,
})

export type RootState = ReturnType<typeof rootReducer>
